(function () {
  // Exact SVG from theme's /assets/icon-filter.svg
  var FILTER_ICON_SVG =
    '<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M16.823 6h-12m10 4h-8m2 4h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
    '</svg>';

  function getLabelFromThemeButton() {
    // Read the already-translated label from the hidden mobile button Horizon renders.
    // This way the label follows the current Shopify locale automatically.
    var themeBtn = document.querySelector('.facets-toggle__button');
    if (!themeBtn) return 'Filters';
    // Clone and strip out nested elements (svg, count bubble) to get clean text
    var clone = themeBtn.cloneNode(true);
    clone.querySelectorAll('svg, .svg-wrapper, .filter-count-bubble').forEach(function (n) {
      n.remove();
    });
    var text = (clone.textContent || '').trim();
    return text || 'Filters';
  }

  function init() {
    var drawer = document.getElementById('filters-drawer');
    if (!drawer) return;

    var toolbar = document.querySelector('.facets.facets--horizontal.facets-controls-wrapper');
    if (!toolbar) return;

    // Avoid double-injection on section re-render
    if (toolbar.querySelector('.leo-filter-trigger')) return;

    var label = getLabelFromThemeButton();

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'leo-filter-trigger button button-unstyled button-unstyled--with-icon';
    btn.setAttribute('aria-label', label);
    btn.innerHTML =
      '<span class="svg-wrapper leo-filter-trigger__icon" aria-hidden="true">' + FILTER_ICON_SVG + '</span>' +
      '<span class="leo-filter-trigger__label">' + label + '</span>';

    btn.addEventListener('click', function () {
      if (typeof drawer.showDialog === 'function') {
        drawer.showDialog();
      } else {
        var hiddenBtn = document.querySelector('.facets-toggle__button');
        if (hiddenBtn) hiddenBtn.click();
      }
    });

    toolbar.insertBefore(btn, toolbar.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:load', init);

  var observer = new MutationObserver(function () {
    if (!document.querySelector('.leo-filter-trigger')) {
      init();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
